<!-- eslint-disable no-unreachable -->
<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="500px" persistent>
      <v-card :loading="loading">
        <v-card-title>
          <span class="subtitle-1">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px">
          <ValidationObserver ref="form">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12" sm="6">
                    <ValidationProvider name="Placa" rules="required">
                      <v-text-field
                        v-model="placa"
                        label="Placa"
                        ref="searchbar"
                        required
                        slot-scope="{ errors, valid }"
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>
                    <v-list-item-title class="primary--text" v-if="showOrigen">
                      Vehículo consultado desde {{ datosVehiculo.origen }}
                    </v-list-item-title>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <ValidationProvider name="Relación" rules="required">
                      <v-select
                        v-model="relacion"
                        :items="tipoRelacion"
                        item-text="tipo"
                        item-value="tipo"
                        label="Relación con el vehículo"
                        @change="limpiarCC"
                        required
                        slot-scope="{ errors, valid }"
                        :error-messages="errors"
                        :success="valid"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <ValidationProvider name="Identificación" rules="required">
                      <v-text-field
                        v-model="identificacion"
                        label="Identificación"
                        required
                        slot-scope="{ errors, valid }"
                        :error-messages="errors"
                        :success="valid"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-alert
                      style="cursor: pointer"
                      v-if="showRgistroUs"
                      @click="registrarUs(identificacion)"
                      dense
                      outlined
                      text
                      type="info"
                    >
                      Registrar Conductor<strong> Aquí</strong>
                    </v-alert>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <ValidationProvider name="Tipo de caso" rules="required">
                      <v-select
                        v-model="objDatos.tipocaso"
                        :items="tipoCaso"
                        item-text="tipo"
                        item-value="tipo"
                        label="Tipo de caso"
                        required
                        slot-scope="{ errors, valid }"
                        :error-messages="errors"
                        :success="valid"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <ValidationProvider name="Empresa" rules="required">
                      <v-autocomplete
                        v-model="objDatos.uidempresa"
                        :items="empresas"
                        item-text="empresa"
                        item-value="id"
                        label="Empresa"
                        required
                        slot-scope="{ errors, valid }"
                        :error-messages="errors"
                        :success="valid"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <ValidationProvider
                      name="Tipo de producto"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="objDatos.tipo_producto"
                        :items="tipoProducto"
                        item-text="nombre"
                        item-value="nombre"
                        label="Tipo de producto"
                        required
                        slot-scope="{ errors, valid }"
                        :error-messages="errors"
                        :success="valid"
                      ></v-autocomplete>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card color="green lighten-4" class="pa-4 mt-2">
                  <div class="text-center mb-3">
                    <span
                      class="text-uppercase font-weight-bold green--text text--darken-2"
                      style="font-size: 14px; letter-spacing: 1px"
                    >
                      Lugar del Accidente
                    </span>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <ValidationProvider name="Departamento" rules="required">
                        <v-autocomplete
                          v-model="objDatos.departamento"
                          :items="departamentos"
                          item-text="departamento"
                          item-value="departamento"
                          label="Departamento"
                          required
                          slot-scope="{ errors, valid }"
                          :error-messages="errors"
                          :success="valid"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <ValidationProvider name="Ciudad" rules="required">
                        <v-autocomplete
                          v-model="objDatos.uidciudad"
                          :items="ciudades"
                          item-text="ciudad"
                          item-value="id"
                          label="Ciudad"
                          required
                          slot-scope="{ errors, valid }"
                          :error-messages="errors"
                          :success="valid"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>

                    <v-col cols="12">
                      <ValidationProvider
                        name="Dirección siniestro"
                        rules="required"
                      >
                        <v-text-field
                          v-model="objDatos.direccion_siniestro"
                          label="Dirección del siniestro"
                          placeholder="Ej: Calle 100 # 15-20, Apto 501"
                          required
                          slot-scope="{ errors, valid }"
                          :error-messages="errors"
                          :success="valid"
                        ></v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card>

                <v-card color="blue lighten-4" class="pa-4 mt-2">
                  <div class="text-center mb-3">
                    <span
                      class="text-uppercase font-weight-bold blue--text text--darken-2"
                      style="font-size: 14px; letter-spacing: 1px"
                    >
                      Verificación
                    </span>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <ValidationProvider name="Verificacion" rules="required">
                        <v-autocomplete
                          v-model="objDatos.verificacion"
                          :items="verificacion"
                          item-text="nombre"
                          item-value="nombre"
                          label="Verificación de asegurabilidad"
                          required
                          slot-scope="{ errors, valid }"
                          :error-messages="errors"
                          :success="valid"
                        ></v-autocomplete>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pb-8 pl-8">
          <v-btn
            v-if="!id"
            @click="save"
            color="primary"
            dark
            :loading="loading"
          >
            Guardar
          </v-btn>
          <v-btn
            v-if="id"
            @click="updateCase"
            color="primary"
            dark
            :loading="loading"
          >
            Guardar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <modal-add-us
      v-if="showModalUs"
      :showModal.sync="showModalUs"
      :showRgistroUs.sync="showRgistroUs"
      :identificacion="identificacion"
      :idConductor.sync="idConductor"
      @actualizar3="showRgistroUs"
    ></modal-add-us>
  </v-row>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import { db } from "../../firebase";
import ModalAddUs from "./ModalAddUs.vue";
import moment from "moment";
import WebServiceHub from "@/helpers/WebServiceHub";
import WebServiceTecnicar from "@/helpers/WebServiceTecnicar";

export default {
  name: "ModAdd",
  data() {
    return {
      showModalUs: false,
      showOrigen: false,
      dialog: true,
      loading: true,
      tipoCaso: [],
      empresas: [],
      departamentos: [],
      //itemAreas: [],
      verificacion: [
        { nombre: "Ninguno" },
        { nombre: "Consulta en línea" },
        { nombre: "Verificación contact center" },
      ],
      tipoProducto: [
        { nombre: "Ninguno" },
        { nombre: "Todo riesgo taxis" },
        { nombre: "Conduce tranquilo" },
        { nombre: "Rodando contigo" },
        { nombre: "Tercero esencial" },
        { nombre: "Tercero obligatorio" },
        { nombre: "Todo riesgo pesados" },
        { nombre: "Rc transporte público" },
      ],
      crearChat: {},
      objDatos: {
        estado: "Recibido",
        creado: Date.now(),
        archivado: false,
        localizacion: {
          _lat: 0,
          _long: 0,
        },
        uidabogado: "",
        uidabogadocait: "",
        uidinvestigador: "",
        uidcontactcenter: "",
        uidperito: "",
        uiddibujante: "",
        solicitud_investigador: false,
        solicitud_perito: false,
        solicitud_dibujante: false,
        tipo_plan: "SIN PLAN",
        llegada: false,
        tiempo_llegada_abogado: "",
        tiempo_llegada_investigador: "",
        solicitud_atencion: false,
        aprobar_atencion: false,
        tipo_producto: "",
        uidempresa: "",
        origen: "Firebase",
      },
      placa: "",
      showRgistroPlaca: false,
      showRgistroUs: false,
      datosVehiculos: [],
      relacion: "",
      tipoRelacion: [{ tipo: "Propietario" }, { tipo: "Conductor" }],
      identificacion: "",
      datosPropietario: {},
      datosAfectados: {},
      idVehiculo: "",
      idCliente: "",
      idConductor: "",
      arrayCiudad: [],
      estadoUsuarioLogueado: "",
      consultaPlaca: "",
      polizaVehiculo: {},
      datosVehiculo: {
        origen: "Digipats",
        encontrado: false,
        clase: "SIN CLASE",
        carroceria: "SIN CARROCERIA",
        marca: "SIN MARCA",
        linea: "SIN LINEA",
        modelo: "0000",
        servicio: "PARTICULAR",
        poliza: [],
        estado: "Activo",
        modificacion: Date.now(),
      },
      datosClientes: {
        creado: new Date(),
        duracion_sesion: 15,
        estado: true,
        disponibilidad: "",
        nombres: "",
        apellidos: "",
        identificacion: "",
        telefono: "",
        ciudad: "",
        direccion: "",
        tipoidentificacion: "CC",
      },
      datosEmpresa: {
        empresa: "SIN EMPRESA",
        estado: true,
        nit: "0000",
      },
      direccion: {
        tipo_via: "",
        numero_principal: "",
        numero_secundario: "",
        numero_terciario: "",
        complemento: "",
      },
      tiposVia: ["Cl", "Cra", "Av", "Diag", "Transv", "Autopista", "Trv"],
      numeroCaso: null,
    };
  },
  components: {
    ModalAddUs,
  },
  props: {
    showModal: { type: Boolean, default: false },
    id: { type: String },
  },
  watch: {
    async placa(nuevo) {
      this.consultaPlaca = nuevo.toUpperCase().trim();
      this.datosVehiculo.placa = nuevo.toUpperCase().trim();
      this.objDatos.aprobar_atencion = false;
      this.objDatos.tipo_plan = "SIN PLAN";
      this.identificacion = "";
      this.relacion = "";
      if (nuevo.length <= 5) return;
      this.loading = true;
      await this.consultarVehiculoTecnicar();
      this.idVehiculo = this.datosVehiculo.id;
      this.showOrigen = true;
      this.idCliente = this.datosVehiculo.uidcliente;
      if (this.idCliente) {
        const Propietario = await db
          .collection("clientes")
          .doc(this.idCliente)
          .get();
        this.datosPropietario = Propietario.data();
        this.identificacion = this.datosPropietario.identificacion;
      }
      this.relacion = "Propietario";
      this.loading = false;
    },
    direccion: {
      deep: true,
      handler() {
        let direccionCompleta = "";
        if (this.direccion.tipo_via) {
          direccionCompleta += this.direccion.tipo_via + " ";
        }
        if (this.direccion.numero_principal) {
          direccionCompleta += this.direccion.numero_principal;
        }
        if (this.direccion.numero_secundario) {
          direccionCompleta += " # " + this.direccion.numero_secundario;
        }
        if (this.direccion.numero_terciario) {
          direccionCompleta += " - " + this.direccion.numero_terciario;
        }
        if (this.direccion.complemento) {
          direccionCompleta += " " + this.direccion.complemento;
        }
        this.objDatos.direccion_siniestro = direccionCompleta.trim();
      },
    },
    async identificacion(nuevo) {
      if (nuevo.length <= 0) return;
      const afectado = await db
        .collection("clientes")
        .where("identificacion", "==", nuevo)
        .get();
      this.showRgistroUs = afectado.docs.length != 0 ? false : true;
      if (afectado.docs.length <= 0) return;
      this.datosAfectados = afectado.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      console.log(this.datosAfectados);
      this.idConductor = this.datosAfectados.find((el) => el.id).id;
    },
  },
  computed: {
    ...mapState(["logueado"]),
    tituloModal(props) {
      return props.id ? "ACTUALIZAR" : "AGREGAR";
    },
    // eslint-disable-next-line vue/return-in-computed-property
    ciudades() {
      this.objDatos.departamento;
      const result = this.arrayCiudad.filter(
        (el) => el.departamento === this.objDatos.departamento
      );
      return result;
    },
  },
  async mounted() {
    const tipo = await db.collection("tiposcaso").get();
    this.tipoCaso = tipo.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const empresa = await db.collection("empresas").get();
    this.empresas = empresa.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    const departamentos = await db.collection("departamentos").get();
    this.departamentos = departamentos.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    const ciudad = await db.collection("ciudades").get();
    this.arrayCiudad = ciudad.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    //const area = await db.collection("area").where("estado", "==", true).get();
    //this.itemAreas = area.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  },
  async created() {
    this.getData();
    await this.inicializarContadorGlobal();
    db.collection("casos")
      .where("uidcontactcenter", "==", this.logueado.id)
      .where("archivado", "==", false)
      .get()
      .then((res) => {
        this.estadoUsuarioLogueado =
          res.size > 1 ? "Activo multiple" : "Activo ocupado";
      });
  },
  methods: {
    async getData() {
      try {
        if (this.id) {
          const datos = await db.collection("casos").doc(this.id).get();
          this.objDatos = datos.data();
          const DatosCiudad = await db.collection("ciudades").doc(this.objDatos.uidciudad).get();
          const DatosAfectado = await db.collection("clientes").doc(this.objDatos.uidcliente).get();
          this.identificacion = DatosAfectado.data().identificacion;
          this.objDatos.departamento = DatosCiudad.data().departamento;
          console.log(this.objDatos, "DATOS");
          this.objDatos.tipocaso = (this.objDatos.tipocaso === "Choque Simple") ? 'Choque simple' : this.objDatos.tipocaso;
          const vehiculo = await db
            .collection("vehiculos")
            .doc(this.objDatos.uidvehiculo)
            .get();
          this.placa = vehiculo.data().placa;
        }
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
    async save() {
      try {
        const validar = await this.$refs.form.validate();
        if (!validar) return false;

        if (this.showRgistroUs) throw new Error("Usuario no registrado");

        this.loading = true;

        this.prepareCaseData();
        await this.updateVehicleClient();
        const caseResult = await this.createCase();
        await this.updateCaseNumber(caseResult);
        await this.savePolicies(caseResult);
        await this.updateUserStatus();
        await this.saveTraceability(caseResult);
        await this.createChat(caseResult);
        this.showSuccessMessage();
        this.cerrarModal();
        this.$emit("actualizar");
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },

    prepareCaseData() {
      let direccionCompleta = "";
      if (this.direccion.tipo_via) {
        direccionCompleta += this.direccion.tipo_via + " ";
      }
      if (this.direccion.numero_principal) {
        direccionCompleta += this.direccion.numero_principal;
      }
      if (this.direccion.numero_secundario) {
        direccionCompleta += " # " + this.direccion.numero_secundario;
      }
      if (this.direccion.numero_terciario) {
        direccionCompleta += " - " + this.direccion.numero_terciario;
      }
      if (this.direccion.complemento) {
        direccionCompleta += " " + this.direccion.complemento;
      }

      this.objDatos = {
        ...this.objDatos,
        uidvehiculo: this.idVehiculo,
        placa: this.placa.toUpperCase().trim(),
        uidconductor: this.idConductor,
        uidcreador: this.logueado.id,
        uidcontactcenter: this.logueado.id,
        //area: this.logueado.cargo == "Administrador"
        //          ? this.objDatos.area
        //          : this.logueado?.area ?? "Sin Definir",
        origen_desde: this.id ? this.objDatos.origen_desde : "Digipats",
        ciudad_siniestro: this.ciudades.find(
          (el) => el.id == this.objDatos.uidciudad
        ).ciudad,
        direccion_siniestro:
          direccionCompleta.trim() || this.objDatos.direccion_siniestro || "",
      };
    },

    sanitizarNumeroDireccion(campo, valor) {
      const valorInput =
        typeof valor === "string" ? valor : valor?.target?.value || "";
      const alfanumerico = (valorInput || "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase()
        .slice(0, 4);
      if (this.direccion[campo] !== alfanumerico) {
        this.direccion[campo] = alfanumerico;
      }
    },

    async inicializarContadorGlobal() {
      const snapshot = await db
        .collection("casos")
        .orderBy("caso", "desc")
        .limit(1)
        .get();

      let ultimoNumero = 0;
      if (!snapshot.empty) {
        ultimoNumero = snapshot.docs[0].data().caso; // Obtener el caso más alto
      }

      // Configurar el contador global con el número más alto encontrado
      await db.collection("config").doc("numero_caso").set({ ultimoNumero });

      console.log(`Contador global inicializado en: ${ultimoNumero}`);
    },

    async updateVehicleClient() {
      if (!this.idCliente) {
        await db
          .collection("vehiculos")
          .doc(this.idVehiculo)
          .update({ uidcliente: this.idConductor });
        this.idCliente = this.idConductor;
      }
      this.objDatos.uidcliente = this.idCliente;
    },

    async createCase() {
      const result = await db.collection("casos").add(this.objDatos);
      console.log("Caso creado: ", result);
      return result;
    },
    async updateCase() {
      try {
        const validar = await this.$refs.form.validate();
        if (!validar) return false;

        if (this.showRgistroUs) throw new Error("Usuario no registrado");

        this.loading = true;

        this.prepareCaseData();
        await this.updateVehicleClient();
        await db.collection("casos").doc(this.id).update(this.objDatos);
        this.showSuccessMessage();
        this.cerrarModal();
        this.$emit("actualizar");
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },

    async updateCaseNumberOld(caseResult) {
      /* const numeroCasos = await db.collection("casos").get();
      await db
        .collection("casos")
        .doc(caseResult.id)
        .update({ caso: numeroCasos.size }); */

      const snapshot = await db
        .collection("casos")
        .orderBy("caso", "desc")
        .limit(1)
        .get();

      let nuevoNumeroCaso = 1;
      if (!snapshot.empty) {
        const casoMayor = snapshot.docs[0].data().caso;
        nuevoNumeroCaso = casoMayor + 1;
      }

      await db
        .collection("casos")
        .doc(caseResult.id)
        .update({ caso: nuevoNumeroCaso });
    },

    async updateCaseNumber(caseResult) {
      const numeroCasoRef = db.collection("config").doc("numero_caso");
      const MAX_INTENTOS = 100;

      for (let i = 0; i < MAX_INTENTOS; i++) {
        const nuevoNumeroCaso = await db.runTransaction(async (transaction) => {
          const numeroCasoDoc = await transaction.get(numeroCasoRef);
          let ultimoNumero = 0;

          if (!numeroCasoDoc.exists) {
            const ultimoCasoSnapshot = await db
              .collection("casos")
              .orderBy("caso", "desc")
              .limit(1)
              .get();
            if (!ultimoCasoSnapshot.empty) {
              ultimoNumero = Number(ultimoCasoSnapshot.docs[0].data().caso) || 0;
            }
            transaction.set(numeroCasoRef, { ultimoNumero });
          } else {
            ultimoNumero = Number(numeroCasoDoc.data().ultimoNumero) || 0;
          }

          const siguienteNumero = ultimoNumero + 1;
          transaction.update(numeroCasoRef, { ultimoNumero: siguienteNumero });
          return siguienteNumero;
        });

        const colisionSnapshot = await db
          .collection("casos")
          .where("caso", "==", nuevoNumeroCaso)
          .limit(2)
          .get();
        const existeOtroCaso = colisionSnapshot.docs.some(
          (d) => d.id !== caseResult.id
        );

        if (!existeOtroCaso) {
          this.numeroCaso = nuevoNumeroCaso;
          await db.collection("casos").doc(caseResult.id).update({
            caso: nuevoNumeroCaso,
          });
          console.log(`Número de caso asignado: ${nuevoNumeroCaso}`);
          return;
        }
      }

      throw new Error(
        "No fue posible asignar un número de caso único. Intente nuevamente."
      );
    },

    async savePolicies(caseResult) {
      if (["Tecnicar", "SEGURO TERCERO"].includes(this.datosVehiculo.origen)) {
        const uniquePolicies = this.datosVehiculo.poliza.filter(
          (poliza, index, self) =>
            index === self.findIndex((p) => p.polizas === poliza.polizas)
        );

        await Promise.all(
          uniquePolicies.map((poliza) => {
            const policyData = {
              ...poliza,
              idCaso: caseResult.id,
              // eslint-disable-next-line no-undef
              caso: this.numeroCaso,
              uidcliente: this.objDatos.uidcliente,
              uidvehiculo: this.objDatos.uidempresa,
            };
            return db.collection("polizas").add(policyData);
          })
        );
      }
    },

    async updateUserStatus() {
      await db.collection("usuarios").doc(this.logueado.id).update({
        disponibilidad: this.estadoUsuarioLogueado,
      });

      this.$store.dispatch("updatePerfilLogueado", { id: this.logueado.id });
    },

    async saveTraceability(caseResult) {
      const uidcreador = this.logueado.id;

      await db.collection("trazabilidad").add({
        descripcion: "Se realiza la creación del caso",
        uidcaso: caseResult.id,
        uidcreador,
        fechahora: Date.now(),
      });

      await db.collection("trazabilidadestado").add({
        descripcion:
          "Se asigna estado al usuario dependiendo la cantidad de caso",
        estado: this.estadoUsuarioLogueado,
        uidcaso: caseResult.id,
        cargo: this.logueado.cargo,
        uidcreador,
        uidusuario: uidcreador,
        fechahora: Date.now(),
      });
    },

    async createChat(caseResult) {
      this.crearChat = {
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fvml.ico?alt=media&token=d93de8fc-dc76-4c53-bb6e-f8420d814827",
        roomName: "Chat en proceso (Entrar)",
        uidcaso: caseResult.id,
        unreadCoun: 0,
        users: [],
      };

      const resChat = await db.collection("chats").add(this.crearChat);
      await db
        .collection("chats")
        .doc(resChat.id)
        .update({ roomId: resChat.id });
    },

    showSuccessMessage() {
      this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
    },

    async limpiarCC() {
      this.identificacion = "";
    },
    registrarUs(item) {
      console.log(item);
      this.showModalUs = true;
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async notificacionesCaso(ciudad) {
      const usuarios = await db
        .collection("usuarios")
        .where("ciudades", "array-contains", ciudad)
        .where("cargo", "in", ["Administrador", "Abogado", "Investigador"])
        .get();

      const objUsuNotificar = usuarios.docs.map((e) => ({
        ...e.data(),
      }));

      const usu = objUsuNotificar
        .filter((e) => {
          return e.tokenPush;
        })
        .map((u) => {
          return u.tokenPush;
        });
      usu.length > 0 && (await this.fechNotificaciones(usu)); // Enviar notificaciones
    },
    async fechNotificaciones(registration_ids) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      if (registration_ids.length <= 0) {
        return;
      }

      const dominio =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? "https://sandbox.digipats.com.co"
          : "https://digipats.com.co";
      const ambiente =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
          : process.env.VUE_APP_CLOUDFUNCTIONURL;
      const url = `${ambiente}/enviarNotificacionFcm`;

      const raw = JSON.stringify({
        tokens: [...registration_ids],
        message: {
          notification: {
            title: "Caso creado en tu ciudad",
            body: "Caso nuevo",
          },
          data: {
            url: dominio,
          },
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(url, requestOptions)
        .then((response) => response.json())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    async consultarVehiculoTecnicar() {
      try {
        // Fin consultar vehiculo
        // consultados vehiculos en firebase
        const vehiculos = await db
          .collection("vehiculos")
          .where("placa", "==", this.consultaPlaca.toUpperCase().trim())
          .get();
        const datosVehiculos = vehiculos.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (datosVehiculos.length > 0) {
          this.datosVehiculos = { ...datosVehiculos[0] };
        }
        if (this.datosVehiculos.placa) {
          console.log("digipast");
          const { marca, servicio, placa, modelo, linea, uidcliente, id } =
            this.datosVehiculos;
          this.datosVehiculo.encontrado = true; //quiere decir que el vehiculo esta registrado en Digipats
          this.datosVehiculo.origen = "Digipats"; //de donde consulto la informacion
          this.objDatos.tipo_plan = "SIN PLAN";
          this.datosVehiculo.marca = marca;
          this.datosVehiculo.servicio = servicio;
          this.datosVehiculo.placa = placa;
          this.datosVehiculo.modelo = modelo;
          this.datosVehiculo.linea = linea;
          this.datosVehiculo.id = id;
          this.datosVehiculo.uidcliente = uidcliente;
          // datos cliente
          if (this.datosVehiculo.uidcliente) {
            const Propietario = await db
              .collection("clientes")
              .doc(this.datosVehiculo.uidcliente)
              .get();
            this.datosPropietario = Propietario.data();
            const { nombres, identificacion, telefono, ciudad, direccion } =
              this.datosPropietario;
            this.datosClientes.nombres = nombres;
            this.datosClientes.identificacion = identificacion;
            this.datosClientes.telefono = telefono;
            this.datosClientes.ciudad = ciudad;
            this.datosClientes.direccion = direccion;
          }
          // EMPRESA
          this.datosEmpresa.empresa = "SIN EMPRESA";
        }
        const { planHub, planTenicar } = await this.ConsultasPolizaVehiculo();
        if (planHub.vehicle) {
          const { placa, marca, tipo, modelo, linea } = planHub.vehicle;
          const fechaFin = moment(
            planHub.policy_end_date,
            "D/M/YYYY hh:mm:ss a"
          ).format("YYYY-MM-DD");
          this.datosVehiculo.origen = "SEGURO TERCERO"; //de donde consulto la informacion
          this.objDatos.tipo_plan = "SEGURO TERCERO";
          this.datosVehiculo.marca = marca;
          this.datosVehiculo.servicio = tipo;
          this.datosVehiculo.placa = placa;
          this.datosVehiculo.modelo = modelo;
          this.datosVehiculo.linea = linea;
          this.datosVehiculo.poliza.push({
            nombre_producto: planHub.policy_origin,
            polizas: planHub.policy_number,
            fechaIni: moment(
              planHub.policy_start_date,
              "D/M/YYYY hh:mm:ss a"
            ).format("YYYY-MM-DD"),
            fechaFin: fechaFin,
          });
          const {
            id_propietario,
            nom_propietario,
            dir_propietario,
            tel_propietario,
          } = planHub.propietario;
          // datos clientes
          this.datosClientes.nombres = nom_propietario;
          this.datosClientes.identificacion = id_propietario;
          this.datosClientes.telefono = tel_propietario;
          this.datosClientes.ciudad = "BOGOTA";
          this.datosClientes.direccion = dir_propietario;
          // datos empresa
          this.datosEmpresa.empresa = "SIN EMPRESA";
        }

        if (planTenicar.status === 200) {
          const {
            placa,
            clase,
            marca,
            linea,
            modelo,
            servicio,
            nombre_producto,
            polizas,
            fechaIni,
            fechaFin,
            cliente,
            docliente,
            telefono,
            ciudad,
            direccion,
            empresa,
            deducible,
            ramo,
            estado,
          } = planTenicar;
          this.datosVehiculo.marca = marca;
          this.datosVehiculo.servicio = servicio;
          this.datosVehiculo.placa = placa;
          this.datosVehiculo.modelo = modelo;
          this.datosVehiculo.linea = linea;
          this.datosVehiculo.clase = clase;
          const nuevaPoliza = {
            nombre_producto,
            deducible,
            docliente,
            cliente,
            empresa,
            ramo,
            estado,
            polizas,
            fechaIni,
            fechaFin,
          };
          this.datosVehiculo.poliza.push(nuevaPoliza);
          this.datosVehiculo.origen = "Tecnicar"; //de donde consulto la informacion
          this.objDatos.tipo_plan = "RC PUBLICO";
          this.datosClientes.nombres = cliente;
          this.datosClientes.identificacion = docliente;
          this.datosClientes.telefono = telefono;
          this.datosClientes.ciudad = ciudad;
          this.datosClientes.direccion = direccion;
          this.datosEmpresa.empresa = empresa.toUpperCase();
        }
        if (
          this.datosVehiculo.poliza?.some(
            (poliza) =>
              poliza.fechaFin && moment(poliza.fechaFin).isAfter(moment())
          )
        ) {
          this.objDatos.origen = this.datosVehiculo.origen;
        }
        // cliente
        this.datosVehiculo.uidcliente = await this.crearCliente();

        // empresa
        await this.crearEmpresa();
        if (this.datosVehiculo.encontrado) {
          await db
            .collection("vehiculos")
            .doc(this.datosVehiculo.id)
            .update(this.datosVehiculo);
          // this.datosVehiculo.id = this.datosVehiculos.docs[0].id;
        } else {
          let vehiculo = await db
            .collection("vehiculos")
            .add(this.datosVehiculo);
          console.log("vehiculo creado");
          this.datosVehiculo.id = vehiculo.id;
          this.consultarVehiculoTecnicar();
        }
      } catch ({
        response: {
          data: {
            error: { msj },
          },
        },
      }) {
        this.$swal({
          icon: "error",
          title: "Oops...",
          text:
            msj === "Sin información"
              ? "Oops! el vehiculo no esta registrado en tecnicar"
              : msj,
        });
      }
    },
    async crearCliente() {
      if (!this.datosClientes.identificacion) {
        return null;
      }
      const cliente = await db
        .collection("clientes")
        .where("identificacion", "==", this.datosClientes.identificacion)
        .get();
      const idCliente = cliente.docs.map((doc) => ({
        id: doc.id,
      }));
      if (idCliente.length > 0) return idCliente[0].id;
      const resultCliente = await db
        .collection("clientes")
        .add(this.datosClientes);
      return resultCliente.id;
    },
    async crearEmpresa() {
      if (!this.datosEmpresa.empresa) {
        return null;
      }
      this.objDatos.uidempresa = "";
      const empresas = await db
        .collection("empresas")
        .where("empresa", "==", this.datosEmpresa.empresa)
        .get();
      const idEmpresa = empresas.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      if (idEmpresa.length > 0) {
        this.objDatos.uidempresa = idEmpresa[0].id;
        return;
      }
      const resulEmpresa = await db
        .collection("empresas")
        .add(this.datosEmpresa);
      this.empresas.push({
        ...this.datosEmpresa,
        id: resulEmpresa.id,
      });
      this.objDatos.uidempresa = resulEmpresa.id;
    },
    async ConsultasPolizaVehiculo() {
      const hub = new WebServiceHub();
      const planHub = await hub.consultarVehiculo(this.consultaPlaca);
      const tecnicar = new WebServiceTecnicar();
      const planTenicar = await tecnicar.get(
        `kronos?placa=${this.consultaPlaca}`
      );
      // this.polizaVehiculo = { planHub, planTenicar };
      return { planHub, planTenicar };
    },
  },
};
</script>
